module.exports = __webpack_public_path__ + "img/protect_en.0f2d828a.png";